import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppService } from 'src/@core/services/app.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { API_DOWNLOAD_WO_FULFILMENT } from 'src/@core/services/util/api.endpoints';
import { EnterpriseAdminService } from 'src/app/modules/enterprise-admin/enterprise-admin.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'hour4u-admin-upload-bulk-workorders',
  templateUrl: './upload-bulk-workorders.component.html',
  styleUrls: ['./upload-bulk-workorders.component.scss']
})
export class UploadBulkWorkordersComponent implements OnInit {
  excelFileKey: string | null = null;
  selectedFile: File | null = null;
  isLoading: boolean = false;
  progress: number;
  progressText: string;
  profile = this.appService.getCurrentAccount();
  numberOfChampsAdded: any;

  constructor(
    private http: HttpClient,
    public dialogRef: MatDialogRef<UploadBulkWorkordersComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedJob: any,
    public enterpriseAdminService: EnterpriseAdminService,
    private appService: AppService,
    private notify: NotificationService
  ) { }

  ngOnInit() {
    console.log(this.selectedJob)
  }

  handleFileUploaded(event: { key: string, file: File }) {
    console.log('Received S3 file key:', event.key);
    this.excelFileKey = event.key;
    this.selectedFile = event.file;
    console.log('File received in CreateWorkOrder component:', event.file);
  }

  handleFileDeleted() {
    this.excelFileKey = null;
    this.selectedFile = null;
  }

  downloadSampleFile(event: Event) {
    event.stopPropagation();
    this.http.get(API_DOWNLOAD_WO_FULFILMENT + '/' + this.selectedJob.id)
      .subscribe((response: any) => {
        console.log(response);
        if (response) {
          // this.downloadExcelFile(response.excelFile);
          window.open(response.excelFile, '_blank');
        }
      })
  }

  downloadExcelFile(url: string): void {
    this.http.get(url, { responseType: 'blob' }).subscribe((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'WorkOrders_Fulfilment.xlsx';
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
    });
  }

  // Method to create bulk work order
  createBulkWorkOrder(): void {
    if (!this.selectedFile) {
      console.error('No file selected!');
      return;
    }
    this.isLoading = true;

    this.updateData().then(() => {
      // this.router.navigate(['/enterprise-admin/all/all']);
      this.dialogRef.close(true);
    }).catch(error => {
      console.error('Error during data update:', error);
    });
  }

  updateData(): Promise<void> {
    console.log('Update Data called');
    this.isLoading = true;
    return new Promise((resolve, reject) => {
      this.progress = 1; // Start with the first step: Uploading excel file

      this.enterpriseAdminService.uploadMultipleChampsInBulkWorkOrder(this.selectedFile, this.getRequestPayload()).subscribe(
        (event: any) => {
          console.log("############3", event)
          if (event.type === HttpEventType.UploadProgress) {
            console.log('Uploading file...');
          } else if (event.type === HttpEventType.Response) {
            console.log('Final Response:', event.body);
            this.numberOfChampsAdded = event.body.numberOfChampsAdded;
            // Step 2: Analyzing data after 3 seconds
            setTimeout(() => {
              this.progress = 2;
            }, 3000);

            // Step 3: Creating champs after 6 seconds
            setTimeout(() => {
              this.progress = 3;
            }, 6000);

            // Step 4: champs completed after 9 seconds
            setTimeout(() => {
              this.progress = 4;
              this.notify.showMessage(
                `Champs are being added in workorders!`,
                300000,
                'assets/tick-circle.svg',
                `Champs are being added in workorders, you'll be notified via email on completion.`
              );
              this.downloadExcelFromBulkOrderCreationResponse(event.body.excelFile);
              // Add a delay before resolving and redirecting to allow the last step to be fully visible
              setTimeout(() => {
                this.isLoading = false;
                resolve(); // Resolve the promise when the final step is complete
              }, 2000); // Stay on the last step for 2 more seconds
            }, 9000); // Total of 9 seconds before the last step
          }
        },
        error => {
          this.isLoading = false;
          console.error('Error creating bulk work order:', error);
          reject(error); // Reject the promise if there's an error
        }
      );
    });
  }

  // Method to get request payload
  private getRequestPayload() {
    return {
      jobId: this.selectedJob.id,
      employerId: this.profile.entity.id,
      agencyId: this.profile.entity.id,
      agencyApprovalRequired: false
    };
  }

  downloadExcelFromBulkOrderCreationResponse(excelFile) {
    window.open(`${excelFile}`, '_blank');
  }

}
